var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateReport = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 18,
  height: 18,
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "create report") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "nc-icon-wrapper",
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeWidth: 2,
  transform: "translate(0.5 0.5)",
  fill: "#FFFFFF",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 7,
  x2: 8,
  y2: 7,
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 7,
  x2: 17,
  y2: 7,
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 12,
  x2: 8,
  y2: 12,
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 12,
  x2: 17,
  y2: 12,
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 17,
  x2: 12,
  y2: 17,
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("polyline", {
  points: "13 23 2 23 2 1 22 1 22 13",
  fill: "none",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 20,
  y1: 17,
  x2: 20,
  y2: 23,
  fill: "none",
  strokeMiterlimit: 10,
  "data-color": "color-2"
}), /*#__PURE__*/React.createElement("line", {
  x1: 17,
  y1: 20,
  x2: 23,
  y2: 20,
  fill: "none",
  strokeMiterlimit: 10,
  "data-color": "color-2"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateReport);
export default ForwardRef;